import { Column } from '@tanstack/react-table';

export const LEFT_PINNED_COLUMN_SHADOW_PROPERTY = `--box-shadow-pinned-left`;
export const RIGHT_PINNED_COLUMN_SHADOW_PROPERTY = `--box-shadow-pinned-right`;

export const LEFT_PINNED_COLUMN_SHADOW_VALUE = '-4px 0 4px -4px gray inset';
export const RIGHT_PINNED_COLUMN_SHADOW_VALUE = '4px 0 4px -4px gray inset';

export function getCommonPinningStyles(
  column: Column<unknown>
): React.CSSProperties {
  const isPinned = column.getIsPinned();
  const isLastLeftPinnedColumn =
    isPinned === 'left' && column.getIsLastColumn('left');
  const isFirstRightPinnedColumn =
    isPinned === 'right' && column.getIsFirstColumn('right');

  return {
    boxShadow: isLastLeftPinnedColumn
      ? `var(${LEFT_PINNED_COLUMN_SHADOW_PROPERTY})`
      : isFirstRightPinnedColumn
      ? `var(${RIGHT_PINNED_COLUMN_SHADOW_PROPERTY})`
      : undefined,
    left: isPinned === 'left' ? `${column.getStart('left')}px` : undefined,
    right: isPinned === 'right' ? `${column.getAfter('right')}px` : undefined,
    opacity: isPinned ? 0.95 : 1,
    position: isPinned ? 'sticky' : 'relative',
    width: column.getSize(),
    zIndex: isPinned ? 1 : 0,
  };
}
